module.exports = __webpack_public_path__ + "img/freezer_smallfront.bf03541f.svg";